import { CallApi, handleJSONResponse } from './common';
import { Ownership } from '@services/ownership/types/ownership';
import { NewOwnership } from '@services/ownership/types/new-ownership';
import { SplitUpdate } from '@services/ownership/types/split-update';
import { ValidOwnershipType } from '@services/ownership/types/valid-ownership-type';
import { SplitUpdateRequest } from '@services/ownership/types/split-update-request';

const callAPI = CallApi('ownership');

export const list = async (assetId: string): Promise<Ownership[]> => {
  const response = await callAPI(`/${assetId}`, 'GET');

  return handleJSONResponse(response);
};

export const listByUserId = async (userId: string): Promise<Ownership[]> => {
  const response = await callAPI(`/user/${userId}`, 'GET');

  return handleJSONResponse(response);
};

export const create = async (newOwner: NewOwnership): Promise<Ownership> => {
  const response = await callAPI(`/${newOwner.assetId}`, 'POST', newOwner);

  return handleJSONResponse(response);
};

export const reassignSplits = async (
  assetId: string,
  ownershipType: ValidOwnershipType,
  newSplits: SplitUpdate[],
  newOwnerShips: Ownership[] | undefined
): Promise<SplitUpdateRequest> => {
  const request: SplitUpdateRequest = {
    assetId,
    ownershipType,
    splitUpdate: newSplits,
    newOwnerShips: newOwnerShips || [],
  };
  const response = await callAPI(`/${assetId}`, 'PUT', request);

  return handleJSONResponse(response);
};

export const updateRequestSplit = async (
  assetId: string,
  ownershipId: string,
  value: number
): Promise<SplitUpdate[]> => {
  const request = {
    assetId,
    // ownershipType: ownershipId.split('#')[1],
    // splitUpdate: {
    // assetId: assetId,
    id: ownershipId,
    requestedSplit: value,
    // },
  };

  const response = await callAPI(
    `/${assetId}/split-change-request`,
    'PUT',
    request
  );
  return handleJSONResponse(response);
};

export const update = async (ownership: Ownership): Promise<Ownership> => {
  const response = await callAPI(
    `/${ownership.assetId}/${encodeURIComponent(ownership.id)}`,
    'PUT',
    ownership
  );

  return handleJSONResponse(response);
};

export const updateOrder = async (
  assetId: string,
  newOrder: string[]
): Promise<string[]> => {
  const response = await callAPI(`/${assetId}/order`, 'PUT', newOrder);

  return handleJSONResponse(response);
};

export const remove = async (
  assetId: string,
  ownershipId: string
): Promise<any> => {
  const response = await callAPI(
    `/${assetId}/${encodeURIComponent(ownershipId)}`,
    'DELETE'
  );

  return handleJSONResponse(response);
};
export const removeManager = async (
  artistId: string,
  trackOwnerShip: any,
  merchOwnership: any,
  removeOwnership: string
): Promise<any> => {
  const request = {
    trackOwnerShip:trackOwnerShip,
    merchOwnership:merchOwnership,
    removeOwnership:removeOwnership
  }
  const response = await callAPI(
    `/artist/${encodeURIComponent(artistId)}`,
    'POST',
    request
  );

  return handleJSONResponse(response);
};
